import { createScale } from '../internal';
import { type NEWS2Bounds, NEWS2ClinicalRisk } from '../types';

export const news2Bounds: NEWS2Bounds = [
  {
    lower: 0,
    upper: 4,
    score: NEWS2ClinicalRisk.Low,
  },
  {
    lower: 5,
    upper: 6,
    score: NEWS2ClinicalRisk.Medium,
  },
  {
    lower: 7,
    // this is the highest valid NEWS Score
    upper: 21,
    score: NEWS2ClinicalRisk.High,
  },
];

export const news2RiskScale = createScale(news2Bounds, 0);
